import baseRoutes from '@/BaseRoutes'
import BubbleToolTV from '@/views/BubbleToolTV'

const customerRoutes = [
  {
    path: '/:lang/bubbletool_tv',
    name: 'bubbletool-tv',
    component: BubbleToolTV,
    meta: { requiresAuth: true, bodyClass: 'page_bubble_tool_tv' },
  },
]
export default customerRoutes.concat(baseRoutes)

export const customerBeforeEach = []
